"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTable = _interopRequireDefault(require("./CwTable.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwTable = function CwTable(props) {
  var _cx;

  var className = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, props.className, props.className), (0, _defineProperty2.default)(_cx, _CwTable.default.nested, props.nested), _cx), props.alternatingRowColors ? _CwTable.default.tableAlternateRow : _CwTable.default.table);
  return _react.default.createElement("table", {
    style: props.style,
    className: className
  }, props.children);
};

CwTable.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.arrayOf(_propTypes.default.element)]),

  /**
   * The css class name to be appended to default classname
   */
  className: _propTypes.default.string,

  /**
   * Override the styles of the root element
   */
  style: _propTypes.default.object,

  /**
   * Set to false if alternating row colors are not desired
   */
  alternatingRowColors: _propTypes.default.bool,

  /**
   * Whether the table is a nested table and requires different styles.
   */
  nested: _propTypes.default.bool
};
CwTable.defaultProps = {
  alternatingRowColors: true
};
var _default = CwTable;
exports.default = _default;